import React from 'react';
import classnames from 'classnames';
import { useCountryCode } from 'src/util/getCountryCode';
import { useIsIrishUser } from 'src/util/cookies';
import { useBreakpointMatch } from 'src/hooks/useBreakpoint';
import { FREE_SHIPPING } from 'src/constants/meta';
import { SafeSplitTreatments } from 'src/components/Splitio/SafeSplitTreatments';

import { TrustPilot } from '../TrustPilot/TrustPilot';

import classes from './StaticBanner.scss';

const FEATURE_NAME = 'Red_Top_Banner';

export const StaticBanner = () => {
    return (
        <SafeSplitTreatments names={[FEATURE_NAME]}>
            {(treatments) => <StaticBannerInner treatment={treatments[FEATURE_NAME].treatment} />}
        </SafeSplitTreatments>
    );
};

const StaticBannerInner: React.FC<{ treatment: string }> = ({ treatment }) => {
    const isIrishUser = useIsIrishUser();
    const countryCode = useCountryCode();
    const { isMob } = useBreakpointMatch();

    return (
        <strong
            className={classnames(classes.staticBanner, {
                [classes.red]: treatment === 'on',
            })}
        >
            <div>
                <img src={require('../../../static/icons/guarantee.svg')} alt="guarantee icon" />
                <span>{countryCode}’s number one since 1990</span>
            </div>
            {!isIrishUser && (
                <div>
                    <img src={require('../../../static/icons/free-delivery.svg')} alt="free delivery icon" />
                    <span>Get free delivery on orders over {FREE_SHIPPING} net!</span>
                </div>
            )}
            <div>{!isMob && <TrustPilot theme="light" />}</div>
        </strong>
    );
};
